module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "culturalhistory"
  }, [_c('div', {
    staticClass: "bannerbg",
    staticStyle: {
      "background": "#3B8DE3"
    },
    on: {
      "click": function($event) {
        return _vm.handlevideoAction()
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "bannerbg_desc"
  }, [_c('div', {
    staticClass: "bannerbg_desc_title"
  }, [_vm._v(_vm._s(_vm.row.cate_row.name))]), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc_entitle"
  }, [_vm._v(_vm._s(_vm.row.cate_row.s_name))])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "sai-list-wrap"
  }, _vm._l((_vm.row.list), function(v, i) {
    return _c('div', {
      key: i,
      staticClass: "sai-list-row"
    }, [_c('div', {
      staticClass: "sai-name"
    }, [_vm._v(_vm._s(v.title))]), _vm._v(" "), _c('div', {
      staticClass: "sai-date"
    }, [_vm._v(_vm._s(v.jingwai_start_time))]), _vm._v(" "), _c('div', {
      staticClass: "sai-end"
    }, [_vm._v(_vm._s(v.jingwai_baoming_end))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: v.jingwai_tongzhi_id
          }
        }),
        expression: "{ name: 'CmsDetail', query: { id: v.jingwai_tongzhi_id } }"
      }],
      staticClass: "sai-do",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('p', [_vm._v("通知文件")])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sai-list-title"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "sai-list-row"
  }, [_c('div', {
    staticClass: "sai-name"
  }, [_vm._v("活动名称")]), _vm._v(" "), _c('div', {
    staticClass: "sai-date"
  }, [_vm._v("活动时间")]), _vm._v(" "), _c('div', {
    staticClass: "sai-end"
  }, [_vm._v("报名截止")]), _vm._v(" "), _c('div', {
    staticClass: "sai-do"
  }, [_vm._v("操作")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e5a5531","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/jingwaiZhou.vue
// module id = 1542
// module chunks = 0